// extracted by mini-css-extract-plugin
module.exports = {"head":"login_head__2Qj7F","desc":"login_desc__2GtVo","btnGoogle":"login_btnGoogle__JfK-h","btnFb":"login_btnFb__1ocWK"};